import {
  createChangeRequestSchema,
  type ChangeRequestFields,
  type ChangeRequestStatus,
  type CreateChangeRequest,
} from '@stm/contracts';
import type { TranslationKey } from '@stm/i18n';

/** What the guardian typed; an empty box means "no change to this field". */
export interface ChangeRequestForm {
  givenName: string;
  familyName: string;
  dateOfBirth: string;
  email: string;
  phone: string;
  note: string;
}

export const emptyChangeRequestForm: ChangeRequestForm = {
  givenName: '',
  familyName: '',
  dateOfBirth: '',
  email: '',
  phone: '',
  note: '',
};

/** The request to send, or null while nothing valid is proposed. */
export function changeRequestBody(form: ChangeRequestForm): CreateChangeRequest | null {
  const candidate: Record<string, string> = {};
  for (const field of [
    'givenName',
    'familyName',
    'dateOfBirth',
    'email',
    'phone',
    'note',
  ] as const) {
    const value = form[field].trim();
    if (value !== '') candidate[field] = value;
  }
  const parsed = createChangeRequestSchema.safeParse(candidate);
  return parsed.success ? parsed.data : null;
}

export const changeRequestStatusLabelKeys: Readonly<Record<ChangeRequestStatus, TranslationKey>> = {
  pending: 'changeRequests.status.pending',
  approved: 'changeRequests.status.approved',
  rejected: 'changeRequests.status.rejected',
  withdrawn: 'changeRequests.status.withdrawn',
};

export const changeRequestFieldLabelKeys: Readonly<
  Record<keyof ChangeRequestFields, TranslationKey>
> = {
  givenName: 'athletes.givenName',
  familyName: 'athletes.familyName',
  dateOfBirth: 'athletes.dateOfBirth',
  email: 'athletes.email',
  phone: 'athletes.phone',
};

export function changeRequestFieldNames(
  fields: ChangeRequestFields,
): (keyof ChangeRequestFields)[] {
  return (Object.keys(fields) as (keyof ChangeRequestFields)[]).filter(
    (field) => field in changeRequestFieldLabelKeys,
  );
}
